import React from "react"

import * as style from "./Enum.module.scss"

import Enums from "./Enums"

const ParamEnum = ({ param, microcopy }) => (
  <div className={style.enums} data-use-grid={param.enum.length > 5}>
    <p>
      {param.enum?.length === 1 ? (
        <Enums
          list={param.enum}
          prefix={microcopy.text("reference.enum.value_is_always")}
        />
      ) : param.type === "array" ? (
        <Enums
          list={param.enum}
          prefix={microcopy.text("reference.enum.value_is_any_of")}
        />
      ) : (
        <Enums
          list={param.enum}
          prefix={microcopy.text("reference.enum.value_is_one_of")}
        />
      )}
    </p>
  </div>
)

export default ParamEnum
